import React from 'react';
import { PropTypes } from 'prop-types';

import './ToastMessage.css';

export function ToastMessage({ type, children }) {
  const typeDict = {
    success: 'Sucesso',
    error: 'Erro',
    warning: 'Atenção',
    info: 'Informação',
    none: '',
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      {type !== 'none' && (
      <p className="toastCustomClass-messageType">
        {`${typeDict[type]}.`}
        &nbsp;
      </p>
      )}
      <p className="toastCustomClass-messageContent">
        {children}
      </p>
    </div>
  );
}

ToastMessage.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info', 'none']),
  children: PropTypes.string,
};

ToastMessage.defaultProps = {
  type: 'none',
  children: '',
};
